import React, { useState } from "react";
import { Column } from "@ant-design/plots";
import { Button, Modal } from "semantic-ui-react";

const YEARDonut = ({ data, analysis, rcp, ssp, year, key_find, unitType }) => {
  const [openModal, setOpenModal] = useState(false);

  if (!data?.cvar || !data?.rcvar) return null;

  const selectedCVaR = data.cvar[unitType]?.rcp_constant || {};
  const selectedRCVaR = data.rcvar[unitType]?.rcp_constant || {};

  const maxCVaR = data.cvar[unitType]?.rcp_max || 0;
  const maxRCVaR = data.rcvar[unitType]?.rcp_max || 0;
  const yMax = Math.max(maxCVaR, maxRCVaR);

  const years = Object.keys(selectedCVaR);

  const barData = years.flatMap((year) => [
    {
      Year: year,
      Type: "CVaR",
      Value: parseFloat(selectedCVaR[year].toFixed(2)),
    },
    {
      Year: year,
      Type: "RCVaR",
      Value: parseFloat(selectedRCVaR[year].toFixed(2)),
    },
  ]);

  const config = {
    data: barData,
    isGroup: true,
    xField: "Year",
    yField: "Value",
    seriesField: "Type",
    maxColumnWidth: 30,
    minColumnWidth: 30,
    dodgePadding: 5,
    yAxis: {
      max: yMax * 1.25,
      title: {
        text: unitType === "percentage" ? "Loss in %" : "Loss in Million USD",
      },
    },
    label: {
      position: "top",
      style: {
        fontSize: 10,
      },
      //layout: [{ type: "interval-adjust-position" }, { type: "adjust-color" }],
    },
    legend: {
      layout: "horizontal",
      position: "top",
    },
    color: ({ Type }) => (Type === "RCVaR" ? "#1A3670" : "#BFCDF6"),
  };

  return (
    <div>
      <Column {...config} />
      <Button
        style={{
          color: "#18202F",
          backgroundColor: "white",
          borderColor: "#18202F",
          border: "1px solid",
          marginTop: "10px",
        }}
        onClick={() => setOpenModal(true)}
      >
        Key Findings
      </Button>
      <Modal open={openModal} onClose={() => setOpenModal(false)} closeIcon>
        <Modal.Header style={{ backgroundColor: "white" }}>
          Key Findings
        </Modal.Header>
        <Modal.Content>
          {key_find && (
            <p className="key_finding">
              {analysis === "rcp" ? (
                <span>
                  This grouped bar chart compares both RCVaR and CVaR over years
                  (2020–2050). Under RCP scenario{" "}
                  <span className="key_find">{rcp}</span>, CVaR increases by{" "}
                  <span className="key_find">{key_find.increased_by_2030}</span>{" "}
                  times in 2030 and{" "}
                  <span className="key_find">{key_find.increased_by_2050}</span>{" "}
                  times by 2050.
                </span>
              ) : (
                <span>
                  This grouped bar chart compares RCVaR and CVaR over years
                  (2020–2100). Under SSP scenario{" "}
                  <span className="key_find">{ssp}</span>, CVaR increases by{" "}
                  <span className="key_find">{key_find.increased_by_2030}</span>{" "}
                  times in 2030,{" "}
                  <span className="key_find">{key_find.increased_by_2050}</span>{" "}
                  times by 2050, and{" "}
                  <span className="key_find">{key_find.increased_by_2100}</span>{" "}
                  times by 2100.
                </span>
              )}
            </p>
          )}
        </Modal.Content>
      </Modal>
    </div>
  );
};

export default YEARDonut;
